import {
  faBriefcase,
  faBuilding,
  faHandshake,
  faMapMarkerAlt,
  faRocket,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import {
  STATS_CENTRE,
  STATS_CUSTOMER,
  STATS_FARMERS,
  STATS_LOCATION,
  STATS_PARTNERS,
  STATS_PRODUCTS,
} from "./navbar/menu";

export const statsDetails = [
  { icon: faMapMarkerAlt, number: 5, detail: STATS_LOCATION },
  { icon: faUsers, number: 200000, detail: STATS_FARMERS },
  { icon: faBriefcase, number: 200, detail: STATS_CUSTOMER },
  { icon: faRocket, number: 2000, detail: STATS_PRODUCTS },
  { icon: faHandshake, number: 100, detail: STATS_PARTNERS },
  { icon: faBuilding, number: 40, detail: STATS_CENTRE },
];
